import { defineStore } from 'pinia';
import api from '@/services/api';

export const useMotivosStore = defineStore('motivosStore', {
  state: () => ({
    motivosList: [],
    page: 1,
  }),
  actions: {
    async findAllMotivosHTTP(tipoMotivo) {
      const result = await api.get('/motivo-rechazo', {
        params: {
          page: +this.page,
          sortBy: 'Descripcion',
          sort: 'asc',
          Activo: true,
          TipoMotivo: tipoMotivo,
        },
      });
      if (result && result.data) {
        this.motivosList.splice(0, this.motivosList.length, ...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },

    async firstMotivos(tipoMotivo) {
      this.setPage(1);
      this.emptyList();
      await this.findAllMotivosHTTP(tipoMotivo);
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.motivosList = [];
    },
  },
});
